import { useState, useContext } from 'react';
import Layout from '../../components/admin/Layout';
import ContextStates from '../../context/ContextStates';
import ListadoModelos from '../../components/admin/listadoModelos';
import FormBusquedaModelo from '../../components/forms/formBusquedaMarca';
import { FaPlus } from "react-icons/fa";

const Modelos = () => {
    const { setFormView, setViewOpen } = useContext(ContextStates)

    const handleAdd = () => {
        setFormView(16)
        setViewOpen(true)
    }

    return (
        <Layout
            pagina={"Modelos"}
        >
            <div className='w-full'>
                <div className='w-full p-2 min-h-full'>
                    <h2 className='mt-10 mb-5 text-gray-600 text-3xl text-center'>Modelos</h2>
                    <div className='w-full h-16 py-2 px-10 bg-slate-50 flex'>
                        <div className='w-1/4'>
                            <button type='button'
                                className='bg-indigo-600 hover:bg-indigo-400 p-3 rounded-md text-white uppercase flex'
                                onClick={() => handleAdd()}
                            >
                                <FaPlus className='mr-2 text-xl' />Agregar Modelos
                            </button>
                        </div>
                        <div className='w-3/4'>
                            <FormBusquedaModelo />
                        </div>
                    </div>
                    <div className='w-full h-full p-10 bg-white'>
                        <ListadoModelos />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Modelos